export const isRequired = (message: string) => (value: unknown) =>
  value ? undefined : message;
